var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"variant":"warning","show":""}},[_c('b-icon',{staticClass:"mr-2",attrs:{"icon":"exclamation-triangle"}}),_c('strong',[_vm._v("Vista en progreso")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }